import React, {useEffect, useState} from "react";
import OrderService from "../../../../API/orders/orders/organization/OrderService";
import DataUtil from "../../../../utils/common/DataUtil";
import OrderTable from "../../../../components/UI/table/orders/organization/order/OrderTable";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {Paper} from "@mui/material";
import ButtonSelectAction from "../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../components/UI/modal/ModalSelectAction";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../../Constants";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {OrderTableFilterData} from "../../../../data/FilterTables/OrderTableFilterData";
import {orderStatus, EMPTY_STATUS_FILTER, EMPTY_PLAN_FILTER, EMPTY_ORDER_NUMBER_FILTER, EMPTY_CUSTOMER_NUMBER_FILTER, EMPTY_CUSTOMER_FILTER, EMPTY_HEADER_FILTER, EMPTY_ATTRIBUTES_FILTER, EMPTY_MODEL_FILTER} from "../../../../data/OrderStatus";

const OrdersForWriteOff = () => {
    const [data, setData] = useState([]);

    const [customerList, setCustomerList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [planningList, setPlanningList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [numberList, setNumberList] = useState([]);
    const [numberCustomerList, setNumberCustomerList] = useState([]);
    const [rowSelection, setRowSelection] = useState([]);
    const [open, setOpen] = useState(false)
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState?.pageSize !== tableOptions?.pageSize) {
            EditLocalStoragePagesData(`organization/for-write-off`, "pageSize", nextState?.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OrderTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OrderTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/for-write-off`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/for-write-off`]?.pageSize
        const searchQuery = pagesData[`organization/for-write-off`]?.searchQuery

        return {searchQuery, pageSize}
    }

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const setLists = (data) => {
        setCustomerList(DataUtil.getListField(data, 'customerName', EMPTY_CUSTOMER_FILTER));
        setNameList(DataUtil.getListChildField(data, 'header', 'name', EMPTY_HEADER_FILTER));
        setModelList(OrderUtil.getEstimateModuleNamesList(data, EMPTY_MODEL_FILTER));
        setAttributeList(OrderUtil.getStatuses(data, 'attributes', EMPTY_ATTRIBUTES_FILTER));
        setPlanningList(DataUtil.getListChildField(data, 'plan', 'name', EMPTY_PLAN_FILTER));
        setStatusList(OrderUtil.getListFieldByEnum(data, 'status', orderStatus, EMPTY_STATUS_FILTER));
        setNumberList(DataUtil.getListField(data, 'number', EMPTY_ORDER_NUMBER_FILTER));
        setNumberCustomerList(DataUtil.getListField(data, 'numberCustomer', EMPTY_CUSTOMER_NUMBER_FILTER));
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        getStartPageSize()
        OrderService.getOrdersForWriteOff().then(function (response) {
            const data = response?.data.sort((a, b) => b.id - a.id)
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setLists(data)
        })
            .catch(function (error) {
                handleModalAlert(error, "error");
            });
    }, []);

    const modalActions = [
        {name: "Действие1", type: "action1"},
        {name: "Действие2", type: "action2"},
    ]

    const handleSelectAction = () => {
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"На списание"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        На списание
                    </Typography>
                </Box>
                <OrderTable
                    data={data}
                    setData={setData}
                    customerList={customerList}
                    nameList={nameList}
                    modelList={modelList}
                    attributeList={attributeList}
                    planningList={planningList}
                    numberList={numberList}
                    numberCustomerList={numberCustomerList}
                    enableEditing={true}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    forWriteOff={true}
                    enableRowSelection={false}
                    handleModalAlert={handleModalAlert}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                    setLists={setLists}
                    statusList={statusList}
                />
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                    autoHide={false}
                />
            </Box>
        </Box>
    );
};

export default OrdersForWriteOff;